/*! StartNoStringValidationRegion DateTime Formats */
export enum State {
  Available = "Available",
  NotAvailable = "NotAvailable",
  NotLoaded = "NotLoaded",
}
/*! EndNoStringValidationRegion */
